import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Container } from '../../styles/StyledComponents';

// Import the TechRamp logo
import logo from '../../assets/logo.svg';

const FooterSection = styled.footer`
  background-color: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.white};
  padding: 4rem 0 2rem;
`;

const FooterContainer = styled(Container)`
  display: flex;
  flex-direction: column;
`;

const FooterTop = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 3rem;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    gap: 2rem;
  }
`;

const FooterLogo = styled.div`
  margin-bottom: 1rem;
`;

const Logo = styled.img`
  height: 40px;
`;

const FooterTagline = styled.p`
  max-width: 300px;
  margin-bottom: 1.5rem;
  opacity: 0.8;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
`;

const SocialIcon = styled.a`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.white};
  transition: all ${({ theme }) => theme.transitions.standard};
  
  &:hover {
    background-color: ${({ theme }) => theme.colors.primary};
    transform: translateY(-3px);
  }
`;

const FooterNav = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const FooterNavColumn = styled.div``;

const FooterNavTitle = styled.h4`
  font-size: 1.1rem;
  margin-bottom: 1.5rem;
  color: ${({ theme }) => theme.colors.white};
`;

const FooterNavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const FooterNavItem = styled.li`
  margin-bottom: 0.75rem;
`;

const FooterNavLink = styled(Link)`
  color: rgba(255, 255, 255, 0.7);
  transition: all ${({ theme }) => theme.transitions.standard};
  
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
`;

const Copyright = styled.p`
  font-size: 0.9rem;
  opacity: 0.7;
`;

const FooterBottomLinks = styled.div`
  display: flex;
  gap: 1.5rem;
`;

const FooterBottomLink = styled(Link)`
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
  transition: all ${({ theme }) => theme.transitions.standard};
  
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterSection>
      <FooterContainer>
        {/* Footer top section with navigation hidden for now */}
        {/* <FooterTop>
          <div>
            <FooterLogo>
              <Logo src={logo} alt="TechRamp Logo" />
            </FooterLogo>
            <FooterTagline>
              Transforming businesses with enterprise-grade AI automation solutions.
            </FooterTagline>
            <SocialLinks>
              <SocialIcon href="https://www.linkedin.com/company/99070146/admin/dashboard/" target="_blank" rel="noopener noreferrer">
                in
              </SocialIcon>
            </SocialLinks>
          </div>
          
          <FooterNav>
            <FooterNavColumn>
              <FooterNavTitle>Company</FooterNavTitle>
              <FooterNavList>
                <FooterNavItem>
                  <FooterNavLink to="/about">About Us</FooterNavLink>
                </FooterNavItem>
                <FooterNavItem>
                  <FooterNavLink to="/team">Our Team</FooterNavLink>
                </FooterNavItem>
                <FooterNavItem>
                  <FooterNavLink to="/careers">Careers</FooterNavLink>
                </FooterNavItem>
                <FooterNavItem>
                  <FooterNavLink to="/contact">Contact</FooterNavLink>
                </FooterNavItem>
              </FooterNavList>
            </FooterNavColumn>
            
            <FooterNavColumn>
              <FooterNavTitle>Services</FooterNavTitle>
              <FooterNavList>
                <FooterNavItem>
                  <FooterNavLink to="/services/client-communications">Client Communications</FooterNavLink>
                </FooterNavItem>
                <FooterNavItem>
                  <FooterNavLink to="/services/sales-marketing">Sales & Marketing</FooterNavLink>
                </FooterNavItem>
                <FooterNavItem>
                  <FooterNavLink to="/services/customer-onboarding">Customer Onboarding</FooterNavLink>
                </FooterNavItem>
                <FooterNavItem>
                  <FooterNavLink to="/services/data-analysis">Data Analysis</FooterNavLink>
                </FooterNavItem>
              </FooterNavList>
            </FooterNavColumn>
            
            <FooterNavColumn>
              <FooterNavTitle>Resources</FooterNavTitle>
              <FooterNavList>
                <FooterNavItem>
                  <FooterNavLink to="/blog">Blog</FooterNavLink>
                </FooterNavItem>
                <FooterNavItem>
                  <FooterNavLink to="/case-studies">Case Studies</FooterNavLink>
                </FooterNavItem>
                <FooterNavItem>
                  <FooterNavLink to="/webinars">Webinars</FooterNavLink>
                </FooterNavItem>
                <FooterNavItem>
                  <FooterNavLink to="/faq">FAQ</FooterNavLink>
                </FooterNavItem>
              </FooterNavList>
            </FooterNavColumn>
          </FooterNav>
        </FooterTop> */}
        
        <FooterBottom style={{ borderTop: 'none', paddingTop: '0' }}>
          <Copyright>
            {`© ${currentYear} TechRamp. All rights reserved.`}
          </Copyright>
          
          <FooterBottomLinks>
            <FooterBottomLink to="/terms">Terms</FooterBottomLink>
            <FooterBottomLink to="/privacy">Privacy</FooterBottomLink>
            <FooterBottomLink to="/cookies">Cookies</FooterBottomLink>
          </FooterBottomLinks>
        </FooterBottom>
      </FooterContainer>
    </FooterSection>
  );
};

export default Footer;
